import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import i18n from "./lang/i18n";
import { I18nextProvider } from "react-i18next";
import keyring from "@polkadot/ui-keyring";
import { cryptoWaitReady } from "@polkadot/util-crypto";

const root = ReactDOM.createRoot(document.getElementById("root"));

cryptoWaitReady().then(() => {
    keyring.loadAll({ ss58Format: 42, type: "sr25519" });
    root.render(
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </Provider>
    );
});
